export default "__VITE_ASSET__DIdb3tXz__"